<i18n>
{
    "en_US": {
        "add-tag": "Add a tag",
        "no-tags-yet": "No tags yet"
    },
    "fr_FR": {
        "add-tag": "Ajouter un tag",
        "no-tags-yet": "Pas encore de tags"
    }
}
</i18n>

<template>
    <div class="btn-group">
        <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-hashtag" aria-hidden="true"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right dropdown-tags">
            <ul v-if="selectedNote.tags && selectedNote.tags.length > 0" class="selected">
                <li v-bind:key="tag" v-for="tag in selectedNote.tags" class="dropdown-item">
                    <span>{{tag}}</span>
                    <i class="fa fa-times" v-on:click="remove"></i>
                </li>
            </ul>
            <a v-else class="dropdown-item disabled" v-text="$t('no-tags-yet')"></a>
            <div class="dropdown-divider"></div>
            <div class="dropdown-input">
                <div class="input-group">
                    <input type="text" class="form-control bmb-control" v-bind:placeholder="$t('add-tag')" v-on:keyup.enter.prevent="add" />
                    <div class="input-group-append">
                        <i class="fa fa-plus" v-on:click.prevent="add"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";

    export default {
        name: "TagsSelector",
        computed: {
            ...mapState("note", ["selectedNote"])
        },
        mounted: function() {
            // Fixing a bug between bootstrap and material design...
            $(this.$el).find("button").dropdown();
            $(this.$el).find(".dropdown-menu").on("click", function(e) {
                e.stopPropagation();
            });
        },
        methods: {
            add: function() {
                const input = $(this.$el).find("input");
                const value = input.val();
                input.val("");
                this.addTag(value);
            },
            remove: function(event) {
                const value = $(event.target).closest("li").find("span").html();
                this.removeTag(value);
            },
            ...mapMutations("note", ["addTag", "removeTag"])
        }
    };
</script>

<style scoped>

    .btn-default, .btn-primary {
        margin-top: 1px;
        margin-bottom: 0;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        background-image: none;
        vertical-align: top;
        -webkit-font-smoothing: subpixel-antialiased;
        font-size: 12px;
        transition: border 0.2s linear 0s, color 0.2s linear 0s, width 0.2s linear 0s, background-color 0.2s linear 0s;
        border-radius: 0.1rem;
        text-shadow: 0 -1px 0 rgba(0,0,0,.2);
        display: inline-block;
        padding: 6px 12px;
        font-weight: 100;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        touch-action: manipulation;
        cursor: pointer;
        user-select: none;
    }

    .dropdown-item {
        padding-left: 15px;
        padding-right: 15px;
    }

    .dropdown-menu > a {
        font-size: 14px;
        color: #666;
        font-weight: 100;
    }

    .fa-hashtag {
        margin-right: 5px;
    }

    .dropdown-tags ul {
        list-style: none;
        margin-bottom: 0;
        padding-left: 0;
    }
    .dropdown-tags ul li {
        display: flex;
        font-size: 14px;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .dropdown-tags ul li span {
        flex: 1;
        font-weight: 200;
    }
    .dropdown-tags ul li i {
        cursor: pointer;
        color: #888;
    }
    .dropdown-tags .dropdown-input {
        margin: 0 10px;
    }
    .dropdown-tags .dropdown-input input {
        font-size: 14px;
    }
    .dropdown-tags .dropdown-input input::-webkit-input-placeholder {
        font-size: 14px !important;
        font-weight: 200;
    }
    .dropdown-tags .dropdown-input input:-moz-placeholder { /* Firefox 18- */
        font-size: 14px !important;
        font-weight: 200;
    }
    .dropdown-tags .dropdown-input input::-moz-placeholder {  /* Firefox 19+ */
        line-height: 20px;
        font-size: 14px !important;
        font-weight: 200;
    }
    .dropdown-tags .dropdown-input .input-group-append i {
        font-size: 14px;
        padding-top: 9px;
        padding-left: 5px;
        cursor: pointer;
        color: #888;
    }
</style>
